// components/EducationDetails.js - 教育经历详情面板
import React, { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export function EducationDetails({ education, onClose }) {
  console.log("Rendering education details for:", education); // 添加调试日志
  
  // 提取标签
  const educationTags = useMemo(() => {
    if (!education) return [];
    
    let tags = [];
    if (education.skills && Array.isArray(education.skills)) {
      tags = [...education.skills];
    }
    if (education.tags && Array.isArray(education.tags)) {
      // 确保不重复添加标签
      education.tags.forEach(tag => {
        if (!tags.includes(tag)) {
          tags.push(tag);
        }
      });
    }
    return tags;
  }, [education]);
  
  // 处理内容中的标签行
  const processedContent = useMemo(() => {
    if (!education || !education.content) return '';
    // 移除标签行
    return education.content.replace(/^(#[\w\u4e00-\u9fa5_-]+\s*)+$/gm, '');
  }, [education]);
  
  if (!education) return null;

  return (
    <div className="experience-details education-overlay-custom"> 
      <div className="details-header" style={{ backgroundColor: (education.color || '#3498db') + '22', borderColor: education.color || '#3498db' }}>
        <h2>{education.name || education.institution || education.title}</h2>
        <button className="close-button" onClick={onClose}>×</button>
      </div>
      
      <div className="details-content">
        <div className="details-summary">
          {education.degree && <p className="location">学历: {education.degree}</p>}
          {education.institution && <p className="location">学校: {education.institution}</p>}
          {education.period && <p className="period">时间: {education.period}</p>}
        </div>
        
        <div className="details-description">
          {education.content ? (
            <ReactMarkdown 
              remarkPlugins={[remarkGfm]}
              components={{
                // 改进图片渲染逻辑
                img: ({node, ...props}) => {
                  // 解析图片URL，修复路径问题
                  let imgSrc = props.src;
                  if (imgSrc && imgSrc.startsWith('/public/')) {
                    imgSrc = imgSrc.substring(7);
                  }
                  
                  return <img src={imgSrc} alt={props.alt || '教育图片'} style={{maxWidth: '100%'}} />
                },
                // 跳过一级标题
                h1: () => null,
                // 过滤包含标签的段落
                p: ({node, ...props}) => {
                  const content = props.children?.toString() || '';
                  if (content.trim().startsWith('#') && content.includes('#')) {
                    return null;
                  }
                  return <p {...props} />
                }
              }}
            >
              {processedContent}
            </ReactMarkdown>
          ) : (
            <>
              {education.description && (
                <>
                  <h4>教育描述</h4>
                  <p>{education.description}</p>
                </>
              )}
              
              {education.achievements && education.achievements.length > 0 && (
                <>
                  <h4>主要成就</h4>
                  <ul>
                    {education.achievements.map((achievement, index) => (
                      <li key={index}>{achievement}</li>
                    ))}
                  </ul>
                </>
              )}
            </>
          )}
          
          {/* 标签显示区域 */}
          {educationTags.length > 0 && (
            <div className="project-tags-section">
              <div className="skills-container">
                {educationTags.map((tag, index) => (
                  <span key={index} className="skill-tag">{tag}</span>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
